export default new class Hook {
    private callbacks: Record<string, CallableFunction[]> = {};

    public subscribe(key: string, callback: CallableFunction) {
        if (!this.callbacks[key]) {
            this.callbacks[key] = [];
        }

        this.callbacks[key].push(callback);

        return () => {
            const index = this.callbacks[key].indexOf(callback);

            if (index !== -1) {
                this.callbacks[key].splice(index, 1);
            }
        };
    }

    public run(key: string, args = []): void {
        if (this.callbacks[key] && this.callbacks[key].length > 0) {
            for (const callback of this.callbacks[key]) {
                callback(...args);
            }
        }
    }
}
